export default __webpack_public_path__ + "static/media/Gesture icons_Squeeze-15.acebda14.svg";